import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroMedico from "../../CadastroMedico/index.tsx";

const CadastroMedicoModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal isOpen={isOpen} title="Cadastro de Médico" onClose={onClose}>
      <CadastroMedico onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroMedicoModal;
